module.exports = __webpack_public_path__ + "static/media/storm.c4661316.png";